package com.cs.ejobin.model

import kotlin.time.Clock
import kotlin.time.ExperimentalTime

sealed class Subscription {
    abstract val isActive: Boolean

    data object None : Subscription() {
        override val isActive: Boolean = false
    }

    data class Active(
        val plan: Plan,
        val validUntilEpochMillis: Long?
    ) : Subscription() {
        @OptIn(ExperimentalTime::class)
        override val isActive: Boolean
            get() = validUntilEpochMillis == null || Clock.System.now().toEpochMilliseconds() < validUntilEpochMillis
    }

    enum class Plan {
        MonthlyTrialThen990,
        Yearly9990
    }
}